(function () {
    'use strict';
    angular.module('app').directive('selectioncommandcopy', selectioncommand_copy);
    function selectioncommand_copy() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                copyDialogShown: '=?'
            },
            controller: 'copy',
            templateUrl: 'app/selectioncommand/selectioncommand_copy.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();